var map = {
	"./100-mil-book-aus.svg": 202,
	"./100-mil-book-es.svg": 203,
	"./100-mil-book.svg": 204,
	"./3000-outlets-aus.svg": 205,
	"./3000-outlets-es.svg": 206,
	"./3000-outlets.svg": 207,
	"./50-countries-aus.svg": 208,
	"./50-countries-es.svg": 209,
	"./50-countries.svg": 210,
	"./70-mil-authors-aus.svg": 211,
	"./70-mil-authors-es.svg": 212,
	"./70-mil-authors.svg": 213,
	"./Componente 6 – 2.svg": 214,
	"./Componente 7 – 2.svg": 215,
	"./Componente 8 – 2.svg": 216,
	"./Facts-and-figures.png": 217,
	"./Google_Play.svg": 218,
	"./Logo_ESP_BRANCO.png": 219,
	"./Logo_ESP_ROXO.png": 220,
	"./X.png": 221,
	"./a4-white.svg": 222,
	"./a4.svg": 223,
	"./a5-white.svg": 224,
	"./a5.svg": 225,
	"./after-01.png": 226,
	"./after-02.png": 227,
	"./after-03.png": 228,
	"./agbook-logo-editor-load.jpg": 229,
	"./agbook-logo-mobile-2.jpg": 230,
	"./agbook-logo-mobile.png": 134,
	"./agbook-logo.png": 231,
	"./ajustes2.png": 232,
	"./alphagraphics.svg": 233,
	"./amex.svg": 234,
	"./ar_on_you.png": 235,
	"./ar_on_you.svg": 236,
	"./arquivo2.png": 237,
	"./article_shortcut.svg": 238,
	"./assistente-de-ia.png": 239,
	"./audiobook-background.png": 240,
	"./authorfreely_primarylogo.png": 122,
	"./auto_stories.svg": 241,
	"./avaliacao2.png": 242,
	"./background-service-all.png": 243,
	"./background-stores.jpg": 244,
	"./banner_partner_stores.png": 245,
	"./bb.svg": 246,
	"./blogger-round-svgrepo-com.svg": 247,
	"./boleto.svg": 248,
	"./book-1-translation.png": 249,
	"./book-1.png": 250,
	"./book-2.png": 251,
	"./book-3.png": 252,
	"./book-de.png": 253,
	"./book-old.png": 254,
	"./book-type-orange.svg": 255,
	"./book-type-red.svg": 256,
	"./book-type.png": 257,
	"./book-type.svg": 258,
	"./book-upload-icon.svg": 259,
	"./book.png": 260,
	"./bookmark_heart.svg": 261,
	"./bottom-background.png": 262,
	"./bradesco.svg": 263,
	"./brand-tiktok-svgrepo-com.svg": 264,
	"./card-icon-1.svg": 265,
	"./card-icon-2.svg": 266,
	"./card-icon-3.svg": 267,
	"./card-icon-4.svg": 268,
	"./card.svg": 269,
	"./chevron-right-black.svg": 270,
	"./chevron-right.svg": 271,
	"./close.svg": 272,
	"./clube-icon-decorator.png": 273,
	"./completed-purchase-book-aus.png": 274,
	"./completed-purchase-book.png": 275,
	"./congratulations-aus.png": 276,
	"./congratulations-de.png": 277,
	"./correcoes2.png": 278,
	"./cover-revision.png": 279,
	"./creditcard.png": 280,
	"./cta-desktop-en.png": 281,
	"./cta-desktop-red.png": 282,
	"./cta-desktop.png": 283,
	"./cta-desktop_de.jpg": 284,
	"./cta-desktop_es.jpg": 285,
	"./cta-mobile-en.png": 286,
	"./cta-mobile-red.png": 287,
	"./cta-mobile.png": 288,
	"./cta-mobile_de.png": 289,
	"./cta-mobile_es.jpg": 290,
	"./dictionary.svg": 291,
	"./diners.svg": 292,
	"./divulgacao2.png": 293,
	"./edit_document.png": 294,
	"./edit_document.svg": 295,
	"./emoji_language.svg": 296,
	"./emotional-analysis_background.png": 297,
	"./epub-conversion-background.png": 298,
	"./epub3-type.png": 299,
	"./esboco.png": 300,
	"./esboco.svg": 301,
	"./facebook-share-pink.svg": 302,
	"./facebook.svg": 303,
	"./facebook2.png": 304,
	"./file-read.png": 305,
	"./first-circle.svg": 306,
	"./format_align_justify.svg": 307,
	"./format_textdirection_r_to_l.svg": 308,
	"./frete-gratis.png": 309,
	"./globe_book.svg": 310,
	"./hand-intelligent.png": 311,
	"./happy-man-using-his-tablet-home-couch_1.png": 312,
	"./happy-man-using-his-tablet-home-couch_2.png": 313,
	"./happy-man-using-his-tablet-home-couch_3.png": 314,
	"./happy-man-using-his-tablet-home-couch_4.png": 315,
	"./heart_plus.svg": 316,
	"./hero-background-mobile.png": 317,
	"./hero-background.png": 318,
	"./hero-book-image.png": 319,
	"./hipercard.svg": 320,
	"./icon-a4.svg": 321,
	"./icon-a5.svg": 322,
	"./icon-add.svg": 323,
	"./icon-amazon.svg": 324,
	"./icon-americanas.svg": 325,
	"./icon-apple.svg": 326,
	"./icon-arrow-down-grey.svg": 327,
	"./icon-arrow-down-purple-orange.svg": 328,
	"./icon-arrow-down-purple-white.svg": 329,
	"./icon-arrow-down-purple.svg": 330,
	"./icon-arrow-left-pagination.svg": 331,
	"./icon-arrow-right-orange.svg": 332,
	"./icon-arrow-right-pagination.svg": 333,
	"./icon-arrow-right-pink.svg": 334,
	"./icon-arrow-right-white.svg": 335,
	"./icon-book-grey.svg": 336,
	"./icon-book-orange.svg": 337,
	"./icon-book-purple.svg": 338,
	"./icon-book-white.svg": 339,
	"./icon-burger-purple.svg": 340,
	"./icon-burger-white.svg": 341,
	"./icon-camera.svg": 342,
	"./icon-cart-grey.svg": 343,
	"./icon-cart-white.svg": 344,
	"./icon-chat-orange.svg": 345,
	"./icon-chat-red.svg": 346,
	"./icon-chat.svg": 347,
	"./icon-check-green.svg": 348,
	"./icon-check-pink.svg": 349,
	"./icon-check-red.svg": 350,
	"./icon-check-white.svg": 351,
	"./icon-chevron_left-orange.svg": 352,
	"./icon-chevron_left-red.svg": 353,
	"./icon-chevron_left.svg": 354,
	"./icon-chevron_right.svg": 355,
	"./icon-close-quote.svg": 356,
	"./icon-cross-purple.svg": 357,
	"./icon-cross-red.svg": 358,
	"./icon-cross-white.svg": 359,
	"./icon-donthave.svg": 360,
	"./icon-download.svg": 361,
	"./icon-ebook-orange.svg": 362,
	"./icon-ebook.svg": 363,
	"./icon-epub.svg": 364,
	"./icon-estantevirtual.svg": 365,
	"./icon-exit-aila-editor.svg": 366,
	"./icon-export.svg": 367,
	"./icon-external.svg": 368,
	"./icon-facebook-purple.svg": 369,
	"./icon-feature-detail.svg": 370,
	"./icon-full-cover.svg": 371,
	"./icon-globe.png": 372,
	"./icon-googleplay.svg": 373,
	"./icon-has.svg": 374,
	"./icon-hasnt.svg": 375,
	"./icon-have.svg": 376,
	"./icon-header-aila-editor.svg": 377,
	"./icon-image-gallery.svg": 378,
	"./icon-image-upload.svg": 379,
	"./icon-livrariacultura.svg": 380,
	"./icon-logo-blog-white.svg": 381,
	"./icon-lp-1-orange.svg": 382,
	"./icon-lp-1-red.svg": 383,
	"./icon-lp-1.svg": 384,
	"./icon-lp-2-orange.svg": 385,
	"./icon-lp-2-red.svg": 386,
	"./icon-lp-2.svg": 387,
	"./icon-lp-3-red.svg": 388,
	"./icon-lp-3.svg": 389,
	"./icon-mercadolivre.svg": 390,
	"./icon-mini-book-orange.svg": 391,
	"./icon-mini-book.svg": 392,
	"./icon-money-orange.svg": 393,
	"./icon-money-purple.svg": 394,
	"./icon-open-chart-orange.svg": 395,
	"./icon-open-chart.svg": 396,
	"./icon-open-quote.svg": 397,
	"./icon-person-grey.svg": 398,
	"./icon-person-white.svg": 399,
	"./icon-play-two.svg": 400,
	"./icon-play.svg": 401,
	"./icon-pocket.svg": 402,
	"./icon-print-orange.svg": 403,
	"./icon-print.svg": 404,
	"./icon-profile-orange.svg": 405,
	"./icon-profile-red.svg": 406,
	"./icon-profile.svg": 407,
	"./icon-quadrado.svg": 408,
	"./icon-questionmark-orange.svg": 409,
	"./icon-questionmark-red.svg": 410,
	"./icon-questionmark.svg": 411,
	"./icon-rakuten.svg": 412,
	"./icon-search-purple-orange.svg": 413,
	"./icon-search-purple.svg": 414,
	"./icon-select-arrow.svg": 415,
	"./icon-separated-cover.svg": 416,
	"./icon-seu-livro-red.png": 417,
	"./icon-seu-livro.png": 418,
	"./icon-speak-orange.svg": 419,
	"./icon-speak-purple.svg": 420,
	"./icon-submarino.svg": 421,
	"./icon-trash-can.svg": 422,
	"./icon-trash.svg": 423,
	"./icon-tu-libro.png": 424,
	"./icon-twitter-purple.svg": 425,
	"./icon-upload-white.svg": 426,
	"./icon-upload.svg": 427,
	"./icon_linkedin.svg": 428,
	"./icons8-check.gif": 429,
	"./idioma-33.png": 430,
	"./img-footer-es.svg": 431,
	"./img-footer.svg": 432,
	"./img-footer_de.jpg": 433,
	"./img2-footer-aus.svg": 434,
	"./img2-footer-es.svg": 435,
	"./img2-footer.svg": 436,
	"./info-orange.svg": 437,
	"./info-pink.svg": 438,
	"./info-red.svg": 439,
	"./info.svg": 440,
	"./info1.jpg": 441,
	"./info2.jpg": 442,
	"./info3.jpg": 443,
	"./instagram-share-pink.svg": 444,
	"./instagram.svg": 445,
	"./instagram3.png": 446,
	"./itau.svg": 447,
	"./kloobr.png": 448,
	"./language-translate.svg": 449,
	"./laptop-cda.png": 450,
	"./linkedin.svg": 451,
	"./lock.svg": 452,
	"./logo-amazon-color.png": 453,
	"./logo-amazon.png": 454,
	"./logo-americanas-color.png": 455,
	"./logo-americanas.png": 456,
	"./logo-apple-color.png": 457,
	"./logo-apple.png": 458,
	"./logo-authorfreely-mobile.png": 123,
	"./logo-cda-mobile.svg": 459,
	"./logo-cda.svg": 460,
	"./logo-club-de-autores.png": 461,
	"./logo-clube-de-autores-share.png": 462,
	"./logo-clube-de-autores-share.svg": 463,
	"./logo-clube-de-autores.svg": 464,
	"./logo-cultura-color.png": 465,
	"./logo-cultura.png": 466,
	"./logo-estante-color.png": 467,
	"./logo-estante.png": 468,
	"./logo-google-color.png": 469,
	"./logo-google.png": 470,
	"./logo-literary-highways.png": 471,
	"./logo-mercado-color.png": 472,
	"./logo-mercado.png": 473,
	"./logo-rakuten-color.png": 474,
	"./logo-rakuten.png": 475,
	"./logo-submarino-color.png": 476,
	"./logo-submarino.png": 477,
	"./lp-banner-a-desktop.png": 478,
	"./lp-banner-a-mobile.png": 479,
	"./lp-banner-b-desktop-red.png": 480,
	"./lp-banner-b-desktop.png": 481,
	"./lp-banner-b-mobile-red.png": 482,
	"./lp-banner-b-mobile.png": 483,
	"./mastercard.svg": 484,
	"./medium-shot-excited-woman-with-laptop-2.png": 485,
	"./medium-shot-excited-woman-with-laptop-mini-1.png": 486,
	"./medium-shot-excited-woman-with-laptop-mini-2.png": 487,
	"./medium-shot-excited-woman-with-laptop-mini-3.png": 488,
	"./medium-shot-excited-woman-with-laptop.png": 489,
	"./metadata.png": 490,
	"./mood_heart.svg": 491,
	"./new-icon-facebook.svg": 492,
	"./new-icon-linkedin.svg": 493,
	"./new-icon-twitter.svg": 494,
	"./norton.svg": 495,
	"./nota-final2.png": 496,
	"./pdf.png": 497,
	"./pix.png": 498,
	"./pocket-white.svg": 499,
	"./pocket.svg": 500,
	"./preco2.png": 501,
	"./privacidade2.png": 502,
	"./psychology.svg": 503,
	"./publico2.png": 504,
	"./publish-book.png": 505,
	"./publish-book_agbook-2.png": 506,
	"./publish-book_agbook.png": 507,
	"./publish-book_en.png": 508,
	"./publish-book_es.png": 509,
	"./quadrado-white.svg": 510,
	"./quadrado.svg": 511,
	"./relatorio2.png": 512,
	"./responsabilidade.png": 513,
	"./room-circle.svg": 514,
	"./second-circle.svg": 515,
	"./sentiment_stressed.svg": 516,
	"./services-footer-1.png": 517,
	"./services-footer-2.png": 518,
	"./services-footer-3.png": 519,
	"./services-footer-4.png": 520,
	"./services-footer-5.png": 521,
	"./slider-arrow-left-grey.svg": 522,
	"./slider-arrow-right-grey.svg": 523,
	"./spellcheck.svg": 524,
	"./stars_1-orange.svg": 525,
	"./stars_1-red.svg": 526,
	"./stars_1.svg": 527,
	"./stars_2-orange.svg": 528,
	"./stars_2-red.svg": 529,
	"./stars_2.svg": 530,
	"./stars_3-orange.svg": 531,
	"./stars_3-red.svg": 532,
	"./stars_3.svg": 533,
	"./stars_4-orange.svg": 534,
	"./stars_4-red.svg": 535,
	"./stars_4.svg": 536,
	"./stars_5-orange.svg": 537,
	"./stars_5-red.svg": 538,
	"./stars_5.svg": 539,
	"./stars_sprint.png": 540,
	"./stars_sprint.svg": 541,
	"./stars_sprint_orange.svg": 542,
	"./stars_sprint_red.svg": 543,
	"./third-circle.svg": 544,
	"./thumb-mini_de.jpg": 545,
	"./twitter-share-pink.svg": 546,
	"./twitter.svg": 547,
	"./user-account-en.png": 548,
	"./user-book.png": 549,
	"./visa.svg": 550,
	"./whatsapp.svg": 551,
	"./word-file-icon.svg": 552,
	"./word-message-aus.svg": 553,
	"./word-message-es.svg": 554,
	"./word-message.svg": 555,
	"./wordpress.svg": 556,
	"./your-book-mini-aus.png": 557,
	"./youtube-play-svgrepo-com.svg": 558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;